// extracted by mini-css-extract-plugin
module.exports = {"monthPopoverItem":"tqlMa","monthPopoverSwapIcon":"j9-vf","monthPopoverCounter":"S+Mp8","monthPopoverSalary":"_7CnPQ"};